import { logger } from '~/features/logging/logger';

import relatedProgramsData from '../../../../related-programs.json';

const popularProgramKeys = [
  'nd027', // Data Engineering with AWS
  'nd089', // AI Programming with Python
  'nd036', // Product Manager
  'nd213', // C++
  'nd098', // Business Analytics
  'nd101', // Deep Learning
  'nd002', // Data Analyst
  'nd0013', // Self Driving Car Engineer
  'nd000', // Introduction to Programming
  'nd0821', // Machine Learning DevOps Engineer
  'nd025', // Data Scientist
  'nd088', // AI Product Manager
  'nd018', // Digital Marketing
  'nd0044', // Full Stack Web Developer
  'nd035', // Java Web Developer
  'nd072', // SQL
];

export function getRelatedProgramKeysFromServer(key?: string): string[] {
  if (!key) {
    return popularProgramKeys;
  }
  const keys = relatedProgramsData[key as keyof typeof relatedProgramsData];
  if (!keys) {
    logger.warn(`Related program keys not found in "related-programs.json" for key "${key}".`, {
      file: 'src/features/program/controllers/get-related-program-keys-from-server.ts',
      function: 'getRelatedProgramKeysFromServer',
    });
    // Note: fallback w/ most popular keys
    return popularProgramKeys;
  }

  return keys;
}
